export const TestIds = {
  errorDialog: {
    container: 'error-dialog-container',
    title: 'error-dialog-title',
    headerCloseButton: 'error-dialog-header-close-button',
    closeButton: 'error-dialog-close-button',
  },
  dashboardFooter: {
    helpHeading: 'dashboard-footer-help-heading',
    visitSettlementText: 'dashboard-footer-visit-settlement-text',
    settlementAssistantButton: 'dashboard-footer-settlement-assistant-button',
    contactInfoText: 'dashboard-footer-contact-info-text',
  },
  dashboard: {
    greeting: 'dashboard-greeting',
    requiresAttentionBanner: 'dashboard-requires-attention-banner',
    dismissBannerButton: 'dashboard-dismiss-banner-button',
    loadingSkeleton: 'dashboard-loading-skeleton',
    claimStatusHeading: 'dashboard-claim-status-heading',
    claimStatusDropdown: 'dashboard-claim-status-dropdown',
    claimStatusText: 'dashboard-claim-status-text',
    settlementAmount: 'dashboard-settlement-amount',
    amountDueOwner: 'dashboard-amount-due-owner',
    documentsHeading: 'dashboard-documents-heading',
    noDocumentsText: 'dashboard-no-documents-text',
    requiresAttentionPill: 'dashboard-requires-attention-pill',
    packageItem: 'dashboard-package-item',
    reviewAndSignButton: 'dashboard-review-and-sign-button',
    downloadPackageButton: 'dashboard-download-package-button',
    trackShipmentButton: 'dashboard-track-shipment-button',
    completeBadge: 'dashboard-complete-badge',
    notesHeading: 'dashboard-notes-heading',
    newMessageButton: 'dashboard-new-message-button',
    smsControl: 'dashboard-sms-control',
    smsYesOption: 'dashboard-sms-yes-option',
    smsNoOption: 'dashboard-sms-no-option',
    smsInfoIcon: 'dashboard-sms-info-icon',
    smsInfoTooltip: 'dashboard-sms-info-tooltip',
    unreadNoteDot: 'dashboard-unread-note-dot',
    importantNoteBadge: 'dashboard-important-note-badge',
  },
  login: {
    emailInput: 'login-email-input',
    passwordInput: 'login-password-input',
    errorMessage: 'login-error-message',
    signInButton: 'sign-in-button',
    loadingContainer: 'loading-container',
    forgotPasswordLink: 'login-forgot-password-link',
  },
  legalRibbon: {
    container: 'legal-ribbon-container',
    termsLink: 'legal-ribbon-terms-link',
    privacyLink: 'legal-ribbon-privacy-link',
  },
  terms: {
    pageTitle: 'terms-page-title',
    termsList: 'terms-list',
  },
  privacy: {
    pageTitle: 'privacy-page-title',
    termsLink: 'privacy-terms-link',
  },
  resetPassword: {
    phoneInput: 'reset-password-phone-input',
    passwordInput: 'reset-password-password-input',
    confirmPasswordInput: 'reset-password-confirm-password-input',
    submitButton: 'reset-password-submit-button',
    errorMessage: 'reset-password-error-message',
    phoneError: 'reset-password-phone-error',
    passwordError: 'reset-password-password-error',
    confirmPasswordError: 'reset-password-confirm-password-error',
    mismatchWarning: 'reset-password-mismatch-warning',
    loadingContainer: 'reset-password-loading-container',
  },
  resetPasswordRequest: {
    emailInput: 'reset-password-request-email-input',
    submitButton: 'reset-password-request-submit-button',
    backToLoginLink: 'reset-password-request-back-to-login-link',
    successMessage: 'reset-password-request-success-message',
    errorMessage: 'reset-password-request-error-message',
    loadingContainer: 'reset-password-request-loading-container',
  },
  addNoteDialog: {
    container: 'add-note-dialog-container',
    textarea: 'add-note-dialog-textarea',
    submitButton: 'add-note-dialog-submit-button',
    cancelButton: 'add-note-dialog-cancel-button',
  },
  viewNoteDialog: {
    container: 'view-note-dialog-container',
    closeButton: 'view-note-dialog-close-button',
    subject: 'view-note-dialog-subject',
    content: 'view-note-dialog-content',
    creator: 'view-note-dialog-creator',
  },
  header: {
    container: 'header-container',
    userInitials: 'header-user-initials',
    dropdownToggle: 'header-dropdown-toggle',
    dropdownMenu: 'header-dropdown-menu',
    accountInfoButton: 'header-account-info-button',
    logoutButton: 'header-logout-button',
  },
  accountInfoModal: {
    container: 'account-info-modal-container',
    closeButton: 'account-info-modal-close-button',
  },
  register: {
    phoneInput: 'register-phone-input',
    passwordInput: 'register-password-input',
    confirmPasswordInput: 'register-confirm-password-input',
    submitButton: 'register-submit-button',
    termsCheckbox: 'register-terms-checkbox',
    termsLink: 'register-terms-link',
    phoneError: 'register-phone-error',
    passwordError: 'register-password-error',
    confirmPasswordError: 'register-confirm-password-error',
    termsError: 'register-terms-error',
    responseError: 'register-response-error',
  },
  optOutSmsModal: {
    container: 'opt-out-sms-modal-container',
    cancelButton: 'opt-out-sms-modal-cancel-button',
    turnOffAllClaimsButton: 'opt-out-sms-modal-turn-off-all-claims-button',
    turnOffThisClaimButton: 'opt-out-sms-modal-turn-off-this-claim-button',
  },
  verificationFormIsDirtyDialog: {
    container: 'verification-form-is-dirty-dialog-container',
    exitWithoutSavingButton: 'verification-form-is-dirty-exit-button',
    continueEditingButton: 'verification-form-is-dirty-continue-button',
  },
  verifyInfo: {
    pageTitle: 'verify-info-page-title',
    claimCounter: 'verify-info-claim-counter',
    submitButton: 'verify-info-submit-button',
    saveButton: 'verify-info-save-button',
    headerEditButton: 'verify-info-header-edit-button',
    formEditButton: 'verify-info-form-edit-button',
    cancelButton: 'verify-info-cancel-button',
    personalInfoSection: 'verify-info-personal-info-section',
    claimInfoSection: 'verify-info-claim-info-section',
    lenderInfoSection: 'verify-info-lender-info-section',
    additionalInfoSection: 'verify-info-additional-info-section',
    loadingSkeleton: 'verify-info-loading-skeleton',
    firstNameInput: 'verify-info-first-name-input',
    cellPhoneField: 'verify-info-cell-phone-field',
    homePhoneField: 'verify-info-home-phone-field',
    address1Field: 'verify-info-address1-field',
    lenderNameInput: 'verify-info-lender-name-input',
    lender2NameInput: 'verify-info-lender2-name-input',
  },
} as const
